import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    email: yup.string().trim().email().nullable().transform((value, originalValue) => {
      return originalValue === '' ? null : value
    }).label('Email'),
  })

const resFilterValuesNotification = yupResolver(schema)

export default resFilterValuesNotification
